import { Button } from "client/designSystem/Button"
import { FormattedMessage } from "react-intl"

import styles from "./EntryDrawnMessage.module.css"

type EntryDrawnMessageProps = {
  onClose: () => void
}

/**
 * Message shown after entry is drawn.
 */
export default function EntryDrawnMessage({
  onClose,
}: EntryDrawnMessageProps) {
  return (
    <div className={styles.container}>
      <p className="body-md">
        <FormattedMessage
          defaultMessage="The host will reach out with instructions on claiming your prize."
          id="giveaways.entryDrawnMessage.message"
        />
      </p>
      <Button
        data-full-width
        type="submit"
        variant="outline"
        onClick={onClose}
      >
        Close
      </Button>
    </div>
  )
}
